/* CK Lager-Cover Produktseite (P017): Schritte als Aufklapp-Menüs. Es ist immer ein Schritt offen; nach der Auswahl öffnet der nächste. */
(function () {
  'use strict';
  var CSS = '' +
    '.ckl-acc{gap:0!important;padding:0!important;overflow:hidden}' +
    '.ckl-acc .ckl-step-head{padding:0;margin:0}' +
    '.ckl-acc .ckl-step-title{width:100%;margin:0}' +
    '.ckl .ckl-acc-btn{appearance:none;-webkit-appearance:none;width:100%;display:flex;align-items:center;gap:10px;min-height:64px;padding:14px 20px;background:none;border:0;cursor:pointer;text-align:left;font:inherit;font-size:19px;font-weight:800;color:#1F2A30;letter-spacing:0;text-transform:none;margin:0}' +
    '.ckl .ckl-acc-btn:hover{background:#FAF9F6}' +
    '.ckl .ckl-acc-btn:focus-visible{outline:3px solid #C9A800;outline-offset:-3px}' +
    '.ckl-acc-lbl{flex:0 0 auto}' +
    '.ckl-acc-val{flex:1 1 auto;min-width:0;text-align:right;font-size:14px;font-weight:700;color:#4A5257;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}' +
    '.ckl-acc-chev{flex:0 0 auto;margin-left:auto;transition:transform .2s ease}' +
    '.ckl-acc.is-open .ckl-acc-chev{transform:rotate(180deg)}' +
    '.ckl-acc.is-open .ckl-acc-val{display:none}' +
    '.ckl-acc.is-done:not(.is-open) .ckl-num{background:#2E7D4F}' +
    '.ckl-acc-panel{display:flex;flex-direction:column;gap:14px;padding:0 20px 20px}' +
    '.ckl-acc-tools{display:flex;justify-content:flex-end}' +
    '.ckl-acc.is-open{border-color:#0B5F73;box-shadow:0 0 0 1px #0B5F73}' +
    '@media (prefers-reduced-motion:reduce){.ckl-acc-chev{transition:none}}' +
    '@media (max-width:600px){.ckl .ckl-acc-btn{padding:12px 16px;font-size:17px}.ckl-acc-panel{padding:0 16px 16px}.ckl-acc-val{font-size:13px}}';

  function addCss() {
    if (document.getElementById('ckl-acc-css')) return;
    var st = document.createElement('style'); st.id = 'ckl-acc-css'; st.textContent = CSS; document.head.appendChild(st);
  }

  function chevron() {
    var ns = 'http://www.w3.org/2000/svg', s = document.createElementNS(ns, 'svg');
    s.setAttribute('class', 'ckl-acc-chev'); s.setAttribute('width', '20'); s.setAttribute('height', '20'); s.setAttribute('viewBox', '0 0 24 24'); s.setAttribute('aria-hidden', 'true');
    var p = document.createElementNS(ns, 'path'); p.setAttribute('d', 'M6 9l6 6 6-6'); p.setAttribute('fill', 'none'); p.setAttribute('stroke', '#0B5F73'); p.setAttribute('stroke-width', '2.4'); p.setAttribute('stroke-linecap', 'round'); p.setAttribute('stroke-linejoin', 'round');
    s.appendChild(p); return s;
  }

  function init(root) {
    if (root.__cklAcc) return;
    var boxes = [].slice.call(root.querySelectorAll('[data-ckl-opts]'));
    if (!boxes.length) return;
    root.__cklAcc = true;
    var steps = [];
    boxes.forEach(function (box, i) {
      var card = box.closest('.ckl-card'); if (!card) return;
      var head = card.querySelector('.ckl-step-head'), title = card.querySelector('.ckl-step-title');
      if (!head || !title) return;
      card.classList.add('ckl-acc');
      var pid = (title.id || ('ckl-acc-' + i)) + '-panel';
      var btn = document.createElement('button'); btn.type = 'button'; btn.className = 'ckl-acc-btn';
      btn.setAttribute('aria-expanded', 'false'); btn.setAttribute('aria-controls', pid);
      var num = title.querySelector('.ckl-num');
      var lbl = document.createElement('span'); lbl.className = 'ckl-acc-lbl';
      [].slice.call(title.childNodes).forEach(function (n) { if (n !== num) lbl.appendChild(n); });
      if (num) btn.appendChild(num);
      btn.appendChild(lbl);
      var val = document.createElement('span'); val.className = 'ckl-acc-val'; btn.appendChild(val);
      btn.appendChild(chevron());
      title.textContent = ''; title.appendChild(btn);
      var panel = document.createElement('div'); panel.className = 'ckl-acc-panel'; panel.id = pid;
      panel.setAttribute('role', 'region'); if (title.id) panel.setAttribute('aria-labelledby', title.id);
      var info = head.querySelector('.ckl-info-link');
      if (info) { var tools = document.createElement('div'); tools.className = 'ckl-acc-tools'; tools.appendChild(info); panel.appendChild(tools); }
      [].slice.call(card.children).forEach(function (ch) { if (ch !== head && ch.tagName !== 'DIALOG') panel.appendChild(ch); });
      card.appendChild(panel);
      steps.push({ card: card, btn: btn, val: val, panel: panel, i: i });
      btn.addEventListener('click', function () { setOpen(current === i ? -1 : i, true); });
    });
    if (!steps.length) return;

    var current = -1;
    function setOpen(idx, focusHead) {
      current = idx;
      steps.forEach(function (s, k) {
        var on = k === idx;
        s.card.classList.toggle('is-open', on);
        s.btn.setAttribute('aria-expanded', on ? 'true' : 'false');
        s.panel.hidden = !on;
      });
      if (focusHead && idx >= 0) {
        var r = steps[idx].card.getBoundingClientRect();
        if (r.top < 0 || r.top > window.innerHeight * 0.6) steps[idx].card.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }

    var sum = root.querySelector('[data-ckl-sum]');
    function refresh() {
      var dds = sum ? sum.querySelectorAll('dd') : [];
      steps.forEach(function (s, k) {
        var t = dds[k] ? dds[k].textContent : '';
        s.val.textContent = t && t !== '–' ? t : '';
        s.card.classList.toggle('is-done', !!s.val.textContent);
      });
    }
    if (sum && window.MutationObserver) new MutationObserver(refresh).observe(sum, { childList: true, subtree: true, characterData: true });
    refresh();

    steps.forEach(function (s, k) {
      s.panel.addEventListener('click', function (e) {
        var opt = e.target && e.target.closest ? e.target.closest('.ckl-opt') : null;
        if (!opt || opt.disabled) return;
        setTimeout(function () {
          refresh();
          if (k < steps.length - 1) setOpen(k + 1, true);
          else {
            setOpen(-1, false);
            var order = root.querySelector('.ckl-order');
            if (order) { var r = order.getBoundingClientRect(); if (r.top < 0 || r.top > window.innerHeight * 0.7) order.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
          }
        }, 0);
      });
    });

    setOpen(0, false);
  }

  function boot() { addCss(); document.querySelectorAll('[data-ckl]').forEach(function (r) { if (r.querySelector('[data-ckl-opts] .ckl-opt')) init(r); else setTimeout(function () { init(r); }, 300); }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { setTimeout(boot, 0); }); else setTimeout(boot, 0);
  document.addEventListener('shopify:section:load', function () { setTimeout(boot, 50); });
})();
